export default function isAddressComplete(address) {
    if (!address) {
        return false;
    }

    const validAddressFields = [ 'streetNumber', 'streetName', 'city', 'province', 'postalCode' ];

    return validAddressFields.every(fieldName => address[fieldName] != null && address[fieldName] !== '');
}
